module.exports = __webpack_public_path__ + "img/menu-item.d3f2477c.svg";